/**
 * JoinENJoinPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinENJoinPage
 */

import { useJoinENJoinPageLogic } from '@/hooks/traits/useJoinENJoinPageLogic';
import type { JoinENJoinPageConfig } from '@/hooks/traits/useJoinENJoinPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinENJoinView as JoinENJoinViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { JoinENJoinHeroView } from '@/components/traits/JoinENJoinHeroView';
import { AnimatedReveal } from '@almadar/ui/components';
import { JoinENJoinWeekDemoView } from '@/components/traits/JoinENJoinWeekDemoView';
import { JoinENJoinFooterView } from '@/components/traits/JoinENJoinFooterView';
import { Container } from '@almadar/ui/components';
import { JoinENJoinHeaderView } from '@/components/traits/JoinENJoinHeaderView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface JoinENJoinPageViewProps {
  config?: Partial<JoinENJoinPageConfig>;
}

export function JoinENJoinPageView({ config: propsConfig }: JoinENJoinPageViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinENJoinPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinENJoinView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinEN" trait="JoinENJoinPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="JoinENJoinPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><JoinENJoinHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><JoinENJoinHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" className="py-16 md:py-24"><AnimatedReveal threshold={0.15} animation="fade-up" trigger="scroll"><Container maxWidth="xl" size="xl" padding="lg"><Stack gap="xl" direction="vertical"><Stack direction="vertical" align="center" gap="sm"><Typography align="center" content={renderPatternValue(__t("std-almadar-join:week.title"))} variant="h2" weight="bold" /><Typography variant="large" align="center" content={renderPatternValue(__t("std-almadar-join:week.body"))} color="muted" /></Stack><JoinENJoinWeekDemoView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack></Container></AnimatedReveal></Box><JoinENJoinFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default JoinENJoinPageView;
